<ms-event-pick
    *rxFor="let option of optionGroup?.options; trackBy: trackOption; let index = index"
    [option]="option"
    [event]="event"
    [optionGroup]="optionGroup"
    [trackingSource]="tracking.source"
    [trackingPosition]="tracking.position"
    [sourceOfPick]="sourceOfPick"
    [isFallbackMarketEnabled]="tracking.isFallbackMarketEnabled"
    [isAutomatedMarquee]="!!tracking.isAutomatedMarquee"
    [marqueeName]="tracking.marqueeName"
    [sitecoreTemplateId]="tracking.sitecoreTemplateId"
    [marqueeType]="tracking.marqueeType"
    [disableOdds]="disableOdds"
    [isFromPortal]="isFromPortal"
    [isPriceBoosted]="isPriceBoosted"
    [betDetails]="tracking.betDetails">
    @if (showCardResultName) {
        <div
            class="card-event-result-name"
            [class.card-result-name-with-img]="hasImage"
            [class.card-result-name]="!hasImage"
            [class.option-offline]="!optionGroup.online || !option.online">
            <div class="card-result-name-inner">
                <div
                    title="{{ option.name }}"
                    [class.card-result-name-text-alt]="optionGroup && optionGroup.options.length > 2"
                    [class.card-result-name-text]="optionGroup && optionGroup.options.length === 2">
                    {{ getOptionName(index) }}
                </div>
            </div>
        </div>
    }

    @if (optionGroup.online && option.online) {
        <span class="card-result-odds option-value" [ngClass]="{ 'odds-right-align': isThreeWayMarketAvailable, 'card-with-img': hasImage }">
            @if (!disableOdds) {
                <ms-font-resizer
                    [value]="(isPriceBoosted ? option.boostedPrice : option.nativePrice) | msNativePriceFormatter"
                    [defaultSize]="1"
                    [maxChars]="6">
                    {{ (isPriceBoosted ? option.boostedPrice : option.nativePrice) | msNativePriceFormatter }}
                </ms-font-resizer>
            }
        </span>
    }
    @if (optionGroup.online && option.online && disableOdds) {
        <div>
            <div class="result-locked"></div>
        </div>
    }

    @if (!optionGroup.online || !option.online) {
        <div>
            <span class="result-locked" *msShowInEpcot="true" [ngClass]="{ 'card-lock-right-align': isOptionNamesAvailable }">
                <vn-icon name="theme-lock" [size]="isLargeLockIcon ? '16' : '13'" />
            </span>
            <span class="result-locked" *msShowInEpcot="false" [ngClass]="{ 'card-lock-right-align': isOptionNamesAvailable }">
                <vn-icon name="theme-locked-i" size="13" />
            </span>
        </div>
    }
</ms-event-pick>
